import React from 'react';
import styled from 'styled-components';
import {
  fontSize,
  fontWeights,
  maxBreakpointQuery,
  minBreakpointQuery,
  sectionMargins,
} from '../styles';
import { Container, Heading, HtmlContent } from './ui';

const StyledLogoContentBlocks = styled.section`
  ${sectionMargins()};
`;

const StyledInner = styled.div`
  ${minBreakpointQuery.mlarge`
    display:grid;
    grid-template-columns: 1fr 2fr;
    align-items: start;
  `}
`;

const StyledHeading = styled(Heading)`
  ${maxBreakpointQuery.mlarge`
    margin-bottom: 40px;
  `}

  ${minBreakpointQuery.mlarge`
    position: sticky;
    top: 30px;
  `}
`;

const StyledItems = styled.div`
  display: grid;
  gap: 40px;

  ${minBreakpointQuery.mlarge`
    gap: 50px;
  `}
`;

const StyledItem = styled.article`
  display: grid;
  gap: 20px;

  ${minBreakpointQuery.small`
    grid-template-columns: 1fr 4fr;
    gap: 35px;
  `}

  ${minBreakpointQuery.mlarge`
    gap: 50px;
  `}
`;

const StyledImage = styled.img`
  margin-right: auto;
  max-height: 60px;

  ${maxBreakpointQuery.small`
    max-width: 180px;
  `}

  ${minBreakpointQuery.small`
    margin-top: 5px;
    margin-left: auto;
  `}
`;

const StyledTextWrapper = styled.div``;

const StyledSubHeading = styled.h3`
  ${fontSize(18)};
  margin-bottom: 10px;
  font-weight: ${fontWeights.medium};

  ${minBreakpointQuery.small`
    margin-bottom: 15px;
    ${fontSize(20)};
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 20px;
    ${fontSize(22)};
  `}
`;

const LogoContentBlocks = ({ heading, items }) => (
  <StyledLogoContentBlocks>
    <Container>
      <StyledInner>
        <StyledHeading>{heading}</StyledHeading>
        <StyledItems>
          {items.map(({ heading, logo, text }, id) => (
            <StyledItem key={id}>
              <StyledImage src={logo.url} alt={logo.alt} loading="lazy" />
              <StyledTextWrapper>
                <StyledSubHeading>{heading}</StyledSubHeading>
                <HtmlContent html={text} />
              </StyledTextWrapper>
            </StyledItem>
          ))}
        </StyledItems>
      </StyledInner>
    </Container>
  </StyledLogoContentBlocks>
);

export default LogoContentBlocks;
